import React from 'react'
import { compose } from 'recompose'
import { Field, reduxForm } from 'redux-form'

import { Form } from 'components'

export const SHOW_CHILD_OVER_VIEW_ON_FORMATIVE_REPORTS_FORM = 'learning_childOverviewSectionOnFormativeReportsVisible'

const ShowChildOverViewOnFormativeReportsForm = ({
  handleSubmit,
  onSubmit,
}) => (
  <Form flex={1} onSubmit={handleSubmit(onSubmit)}>
    <Form.Row>
      <Form.Row.Item>
        <Field component={Form.Switch} name="childOverviewSectionOnFormativeReportsVisible" />
      </Form.Row.Item>
    </Form.Row>
  </Form>
)

const enhance = compose(reduxForm({ form: SHOW_CHILD_OVER_VIEW_ON_FORMATIVE_REPORTS_FORM }))

export default enhance(ShowChildOverViewOnFormativeReportsForm)
